import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.components.maintenanceNoticeModal.title',
    defaultMessage: 'Maintenance Notice',
    description: 'Maintenance Notice Modal title',
  },
  text: {
    id: 'portal.components.maintenanceNoticeModal.text',
    defaultMessage: 'The website is currently undergoing maintenance. '
      + 'If you experience any issues, please contact support and provide a description of the problem.',
    description: 'Maintenance Notice Modal text',
  },
  buttonText: {
    id: 'portal.components.maintenanceNoticeModal.button.text',
    defaultMessage: 'Understood',
    description: 'Maintenance Notice Modal button text',
  },
});

export default messages;
